var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-text-info-block"},[_c('div',{staticClass:"wp-text-info-block__index"},[_vm._v(_vm._s(_vm.index))]),_c('div',{staticClass:"wp-text-info-block__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }